Vendd.Scripts.load(function () {
    initTabPanel();
});

function initTabPanel($wrapper) {
    var $container = $wrapper;

    if (!$container) {
        $container = $('html');
    }

    $('.x-control.x-tab-panel', $container).each(function (i, wrapper) {

        $('*[data-tab-click]', $(wrapper)).click(function () {
          
            $(wrapper).removeClass('default');
            var thisTab = $(this);
            var innerWrapper = thisTab.closest('.x-tab-panel');
            var thisTabIndex = thisTab.data('tab-index');

            if ($('.product-details-region').length > 0) {
                $('li[data-tab-content-index=' + thisTabIndex + ']', innerWrapper).children('.mb-title').addClass('icon-arrow-up').removeClass('icon-arrow-down');
                $('li[data-tab-content-index=' + thisTabIndex + ']', innerWrapper).siblings().children('.mb-title').removeClass('icon-arrow-up').addClass('icon-arrow-down');
            }

            thisTab.addClass('active').siblings().removeClass('active');
            $('li[data-tab-content-index=' + thisTabIndex + ']', innerWrapper).addClass('active').siblings().removeClass('active');

        });
	$('*[data-tab-mobile-click]', $(wrapper)).click(function () {
           
            $(wrapper).removeClass('default');
            var $this = $(this);
            var innerWrapper = $this.closest('.x-tab-panel');
            var thisTabIndex = $this.data('tab-index');

            
            
            $('.x-tab-mobile', innerWrapper).removeClass('icon-arrow-up').addClass('icon-arrow-down');
            $this.removeClass('icon-arrow-down').addClass('icon-arrow-up');
         
            $('li[data-tab-content-index=' + thisTabIndex + ']', innerWrapper).addClass('active').siblings().removeClass('active');
        });

    });
}